<script setup>
  
  import SpecGrid from '../Parts/SpecGrid.vue'
</script>
<template>
    <div class="content">
      <h1>PC Build</h1>
      <SpecGrid :specs="pcSpecs" title="PC Build Specifications" />
      <p>
        Originally, I had a much cheaper build planned, but after a few drinks and months of research,
        I decided to buy it all. Then, at the last minute, I changed everything to <strong>white</strong>.
      </p>

      <h2>What do I use it for and why?</h2>

      <p>
        Initially, I planned to try out <strong>Unraid</strong>, but after researching quite a bit,
        I found multiple reports of <strong>game bans</strong> even with GPU passthrough.
        <strong>Fortnite and COD</strong> were the main ones getting blocked, and since I play Fortnite with my son,
        I needed to ensure my system wouldn’t get banned.
      </p>

      <p>
        Because of this, I stuck with what I already knew. I installed <strong>Windows 11 Professional</strong>,
        set up <strong>Hyper-V</strong>, and created a dedicated <strong>web server VM</strong> inside it.
        Currently, I’ve allocated <strong>10GB of RAM and 10 CPU cores</strong> to this VM.
        So far, I’ve been able to run every game I want at <strong>max settings</strong> while still getting
        well over <strong>60 FPS</strong>.
      </p>

      <p>
        Since I like gaming in my <strong>living room</strong>, my PC is hooked up to my <strong>60-inch TV</strong>.
        I mainly use it for gaming. When I need to do programming or other tasks,
        I typically <strong>remote in from my old Dell laptop</strong>. It works fine for most things, and I can
        even play some games remotely. <strong>FPS is too laggy for fast-paced games</strong>,
        but MMOs like <strong>Black Desert Online</strong> run just fine.
      </p>

      <p>
        Another benefit of using a <strong>VM over a Docker setup</strong> is security.
        I wanted to help a friend set up an easy way to <strong>automate torrents</strong>,
        so I tested setting up a <strong>torrenting VM</strong> with access to <strong>4.5TB of storage</strong>.
        This setup uses multiple pieces of software to handle everything efficiently.
        <a href="/automatic-plex-torrenting"><strong>Click here to see how I did it</strong></a>.
      </p>

    </div>

</template>

<script>
  export default {
    components: {
      SpecGrid
    },
    data() {
      return {
        pcSpecs: [
          { component: "CPU", spec: "INTEL Core™ Ultra 7 265K Unlocked Processor" },
          { component: "Memory", spec: "CRUCIAL Pro 32 GB 6400 MHz DDR5 (16 GB x 2)" },
          { component: "Storage 1", spec: "CORSAIR MP600 ELITE M.2 SSD - 1 TB" },
          { component: "Storage 2", spec: "CORSAIR MP600 ELITE M.2 SSD - 1 TB" },
          { component: "Storage 3", spec: "Old SATA3 240GB SSD" },
          { component: "Storage 4", spec: "WDC WD10JPVX-75JC3T0 HDD - 1 TB" },
          { component: "Storage 5", spec: "Really Old SAMSUNG HD204UI - 2 TB" },
          { component: "Storage 6", spec: "Really Old SAMSUNG HD204UI - 2 TB" },
          { component: "Case", spec: "HYTE Y70 E-ATX Mid-Tower - Snow White" },
          { component: "Power Supply", spec: "MSI MAG A850GL Modular ATX PSU - 850 W" },
          { component: "Motherboard", spec: "MSI PRO Z890-P WIFI LGA1851" },
          { component: "Graphics Card", spec: "MSI GeForce RTX 4060 Ti 8 GB Ventus 3X Black OC" },
          { component: "Cooling", spec: "MSI MAG CORELIQUID I360 360 mm Liquid CPU Cooler - RGB LED, White" },
        ]
      };
    }
  };
</script>
